import React, { useContext } from "react";
import { connect } from "react-redux";
import moment from "moment";
import s from "./firstPage.module.css";
import { TextContext } from "../context/TextContext";
import { messageChatErase } from "../redux/Chat_reducer";

const monthsDict = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

const iconPluses = [
  {
    svgSrc: "svg/iconsPluses/boxes.svg",
    text: "Более 30 видов зеркал и стекла",
  },
  {
    svgSrc: "svg/iconsPluses/mirror.svg",
    text: "Душевые, зеркала, и многое другое",
  },
  { svgSrc: "svg/iconsPluses/guarantee.svg", text: "Гарантия 12 месяцев" },
  { svgSrc: "svg/iconsPluses/stopwatch.svg", text: "Срочный заказ за 24 часа" },
  {
    svgSrc: "svg/iconsPluses/orders.svg",
    text: "Изготовили более 1000 заказов",
  },
  { svgSrc: "svg/iconsPluses/truck.svg", text: "Доставка до вашей двери" },
];

const FirstPage = () => {
  const { data } = useContext(TextContext);
  const date = moment().add(1, "days");
  const dateStr = `${date.format("D")} ${monthsDict[date.month()]}`;
  return (
    <>
      <div className={s.container}>
        <div className={s.mainBlock}>
          <div className={s.info}>
            <h1>{data.companyName ?? "Мосстекло24"}</h1>
            <h2>
              {data.companyDescription ??
                "Производство и установка стеклянных конструкций и зеркал"}
            </h2>
          </div>
          <div className={s.actions}>
            <p>Нужна консультация?</p>
            <div className={s.actionsBtns}>
              <a
                href={data.whatsApp || "https://wa.me/message/V7ZXELBHFBX3L1"}
                rel="noreferrer"
                target="_blank"
                className={s.whatsap}
              >
                Написать нам в
                <svg
                  className={s.wsIcon}
                  viewBox="0 0 1000 1000"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="white"
                >
                  <g>
                    <g>
                      <path d="M473.1,10.44c-87.65,7.87 -161.69,33.57 -232.08,80.37c-119.49,79.59 -197.74,208.48 -212.89,350.42c-2.49,24.17 -2.49,79.02 0.19,102.8c5.95,55.43 22.44,111.44 47.95,163.03l12.66,25.89l-40.47,121.41c-38.94,117 -40.28,121.79 -37.6,126.78c1.73,2.88 5.18,6.52 8.06,8.06c4.6,2.68 13.04,0.77 137.33,-31.84l132.34,-34.91l21.67,9.78c105.3,46.99 225.17,55.05 335.46,22.44c127.16,-37.59 237.26,-130.81 295.37,-250.11c22.63,-46.22 36.06,-89.19 44.3,-140.97c5.18,-31.46 6.14,-100.7 2.11,-130.42c-12.85,-91.1 -48.14,-174.15 -103.57,-243.59c-75.38,-94.17 -187.2,-157.66 -310.14,-175.69c-18.79,-2.68 -83.62,-4.98 -100.69,-3.45Zm-83.154,233.077c9.95,4.37 18.243,10.705 30.905,23.516c14.47,14.777 22.463,25.026 37.688,48.095c13.267,20.2 16.883,29.851 15.979,42.812c-0.904,12.969 -4.677,18.392 -23.069,33.916c-13.715,11.459 -17.488,15.531 -21.41,23.367c-6.178,11.609 -6.484,19.296 -1.203,29.702c5.274,10.556 117.584,122.716 127.385,127.086c16.129,7.388 31.204,1.36 48.543,-19.146c20.655,-24.57 24.876,-27.439 40.549,-27.439c11.153,-0 20.805,3.773 38.293,15.224c23.367,15.225 38.592,27.439 53.965,43.418c17.033,17.787 22.763,28.948 22.763,44.621c-0,16.435 -4.52,24.719 -25.176,45.681c-20.954,21.253 -36.933,33.617 -54.57,41.909c-19.296,9.047 -31.204,11.609 -52.009,11.609c-37.837,-0.299 -74.016,-15.979 -118.338,-51.404c-12.206,-9.809 -150.901,-147.144 -172.304,-170.661c-32.107,-35.275 -53.368,-70.55 -61.503,-101.753c-5.125,-19.752 -5.431,-45.375 -0.904,-62.714c4.071,-15.075 12.969,-32.713 24.271,-47.489c11.609,-15.374 41.304,-44.471 49.596,-48.692c12.961,-6.634 27.887,-7.09 40.549,-1.658Z" />
                    </g>
                  </g>
                </svg>
              </a>
            </div>
          </div>
          <div className={s.svg}>
            <div className={s.svg_bubble + " " + s.corner_bl}>
              Оформите заказ до {dateStr} и получите скидку 20%
            </div>
            <div className={s.svg_bubble + " " + s.corner_tr}>
              Изготовим за 24 часа
            </div>
            <img src={"svg/blik.svg"} id={s.blik} alt={"Блик стекла"} />
            <svg
              width="100%"
              height="100%"
              viewBox="0 50 650 480"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id={s.svgHead}>
                <path
                  d="M461.428 95.9616C448.096 113.083 458.783 135.498 459.478 136.889C461.745 141.472 466.31 150.653 476.815 154.313C487.653 158.094 497.523 153.481 499.927 152.347C514.725 145.42 520.922 129.009 521.013 116.365C521.043 112.569 521.103 104.931 516.1 97.5346C508.225 85.8734 491.704 80.5343 477.964 84.6029C468.638 87.3556 463.242 93.6324 461.428 95.9616Z"
                  fill="white"
                />
                <path
                  d="M490.026 97.1716C494.909 101.149 502.3 108.53 505.414 119.813C505.928 121.659 506.275 123.443 506.502 125.137C507.953 123.216 509.389 121.296 510.84 119.36C512.442 123.292 514.135 129.221 513.44 136.239C513.304 137.661 513.077 138.992 512.79 140.232C513.516 139.975 518.534 138.145 520.59 132.685C522.192 128.435 520.998 124.668 520.65 123.655C519.305 120.025 515.828 112.145 507.802 105.596C500.804 99.8941 493.699 97.9279 490.026 97.1716Z"
                  fill="#AFAFAF"
                />
                <path
                  d="M520.635 123.67C517.642 116.713 513.878 112.054 511.188 109.241C500.093 97.6254 481.622 90.426 465.962 95.9163C462.939 96.9751 460.581 98.3212 459.024 99.3194C459.387 97.6708 460.007 95.3416 461.05 92.6645C462.637 88.5959 466.189 79.5211 474.624 74.3182C482.332 69.569 490.298 70.4008 495.135 70.9151C499.594 71.384 510.039 72.4881 518.398 81.4268C520.877 84.0736 527.936 92.5133 527.497 104.961C527.165 114.641 522.464 121.326 520.635 123.67Z"
                  fill="#4EBFD3"
                />
                <path
                  d="M520.635 123.67C515.103 110.693 508.497 101.376 503.539 95.3263C494.576 84.4063 482.816 70.0831 466.99 70.1587C464.95 70.1739 452.872 70.4764 449.517 78.2959C446.841 84.5273 450.394 93.8744 459.07 100.318C462.713 99.3344 467.867 98.3362 474.079 98.4269C474.079 98.4269 481.169 98.5177 488.243 100.499C505.353 105.294 518.337 120.857 520.635 123.67Z"
                  fill="#49AFBA"
                />
              </g>
              <g id={s.svgHand}>
                <path
                  d="M442.609 159.727C444.196 159.455 454.58 157.671 458.979 162.011C468.199 171.101 446.297 202.47 444.317 205.268C435.898 217.141 406.816 258.19 375.179 252.851C361.424 250.521 352.778 240.373 338.041 223.025C323.847 206.327 315.776 190.143 311.166 178.86C312.405 179.117 320.703 180.736 327.777 175.669C332.115 172.553 333.793 168.515 334.368 166.791C343.739 176.198 353.111 185.606 362.467 195.014C369.466 202.062 376.464 209.11 383.463 216.158C391.05 205.193 398.17 196.435 403.762 190.007C405.909 187.527 413.663 178.679 425.514 169.059C432.618 163.297 436.895 160.711 442.609 159.727Z"
                  fill="#4EBFD3"
                />
                <path
                  d="M335.35 117.817C330.468 115.427 323.303 119.844 321.671 120.857C309.231 128.525 308.46 145.51 307.992 156.067C307.674 162.995 308.385 168.636 308.974 172.16C309.412 184.094 309.836 196.042 310.274 207.976C312.481 208.611 325.404 212.105 338.283 205.238C353.942 196.889 355.741 180.63 355.877 179.133C348.818 174.172 341.759 169.211 334.7 164.265C337.467 154.389 345.704 122.869 335.35 117.817Z"
                  fill="#D1D0D1"
                />
                <path
                  d="M329.893 119.254C336.559 120.282 340.066 131.611 337.708 140.474C334.897 151.016 322.986 161.164 316.063 159.697C309.593 158.321 307.659 146.841 310.077 138.402C312.873 128.677 322.865 118.165 329.893 119.254Z"
                  fill="#D1D0D1"
                />
              </g>
              <path
                d="M441.294 160.015C442.594 159.304 446.343 158.76 453.84 157.655C458.329 156.99 462.063 156.551 464.587 156.294C468.018 158.003 474.125 160.499 482.181 161.074C491.749 161.754 499.201 159.365 502.95 157.882C509.057 157.61 518.232 157.807 528.782 160.605C536.793 162.722 542.159 164.144 544.971 168.288C546.921 171.177 548.372 176.486 538.365 196.133C529.296 213.95 522.041 228.439 504.401 240.978C493.563 248.691 488.137 252.548 480.7 252.125C458.798 250.915 446.826 215.054 442.095 200.912C436.427 183.852 433.782 164.068 441.294 160.015Z"
                fill="#4EBFD3"
              />
              <path
                d="M441.385 158.941C439.722 163.01 438.12 167.35 436.654 171.994C433.102 183.277 431.152 193.743 430.139 202.954C427.585 211.923 423.776 226.11 420.118 243.7C407.496 304.456 407.663 353.355 408.146 408.893C408.328 429.599 409.038 458.502 411.411 493.274C421.69 492.321 433.767 491.882 447.25 492.669C458.345 493.319 468.351 494.68 477.057 496.314C475.153 461.406 474.186 424.955 474.458 387.053C474.594 367.617 475.032 348.606 475.757 329.987C475.788 329.2 477.193 368.041 479.824 440.927C480.73 465.883 481.562 486.377 482.121 500.02C491.644 500.171 501.423 500.473 511.445 500.927C525.563 501.577 539.182 502.53 552.272 503.695C541.691 307.073 532.864 237.318 525.926 220.121C524.762 217.232 518.625 203.393 519.577 185.062C520.182 173.431 523.416 164.083 525.926 158.2C522.782 157.897 519.622 157.595 516.478 157.292C512.941 162.889 508.709 170.905 505.898 181.114C503.419 190.083 502.799 198.008 502.799 204.028C491.583 204.013 479.612 203.574 466.96 202.515C460.491 201.971 454.248 201.306 448.232 200.549C446.917 193.184 446.071 181.87 449.865 168.984C451.301 164.129 453.13 159.924 455.004 156.355C450.469 157.202 445.935 158.064 441.385 158.941Z"
                fill="white"
              />
              <path
                d="M528.283 167.366C529.598 166.761 534.571 164.447 540.058 165.883C540.058 165.883 542.401 166.488 544.472 167.895C550.216 171.782 557.758 194.182 548.266 221.83C544.91 231.57 534.738 261.2 514.634 262.803C502.874 263.741 493.306 254.666 486.293 248.011C466.703 229.438 462.622 205.737 461.609 193.91C464.028 193.516 467.066 192.806 470.407 191.475C474.004 190.053 476.831 188.359 478.871 186.922C484.615 194.046 490.404 201.487 496.208 209.292C500.97 215.689 505.504 221.996 509.812 228.198C509.707 206.993 513.501 192.261 516.327 183.882C518.458 177.59 521.497 170.497 528.283 167.366Z"
                fill="#41CBDD"
              />
              <path
                opacity="0.44"
                d="M465.524 66.2263H319.857V332.634H465.524V66.2263Z"
                fill="white"
              />
              <path
                d="M402.523 529.135L402.72 497.267C397.822 497.524 393.56 497.963 390.023 498.416C377.795 499.989 373.88 501.865 370.962 504.33C367.531 507.234 366.035 510.471 364.614 513.662C361.032 521.648 360.956 529.392 361.682 535.064C375.225 535.109 388.829 535.109 402.478 535.079C418.742 535.033 435.097 534.928 451.512 534.761C460.113 534.67 468.683 534.58 477.254 534.459C477.571 532.84 477.843 531.056 478.07 529.15H402.523V529.135Z"
                fill="white"
              />
              <path
                d="M477.904 511.076C477.299 506.765 476.362 502.908 475.304 499.536C467.081 498.779 458.526 498.144 449.653 497.721C437.259 497.116 425.438 496.919 414.223 497.04C410.096 496.98 406.242 497.07 402.72 497.267L402.523 529.135H478.07C478.675 523.977 478.841 517.867 477.904 511.076Z"
                fill="#41CBDD"
              />
              <path
                d="M408.993 496.995C410.746 498.356 412.998 500.458 414.495 503.226C416.218 506.402 416.233 509.155 415.976 510.924"
                stroke="white"
                strokeWidth="3.2737"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M419.332 496.995C421.085 498.356 423.337 500.458 424.834 503.226C426.557 506.402 426.572 509.155 426.315 510.924"
                stroke="white"
                strokeWidth="3.2737"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <g id={s.svgFoot}>
                <path
                  d="M470.301 537.862L470.497 505.994C465.6 506.251 461.337 506.689 457.8 507.143C445.572 508.716 441.657 510.592 438.74 513.057C435.309 515.961 433.812 519.198 432.391 522.389C428.809 530.375 428.733 538.119 429.459 543.79C443.002 543.836 456.606 543.836 470.255 543.806C486.519 543.76 502.874 543.654 519.29 543.488C527.89 543.397 536.461 543.306 545.031 543.185C545.349 541.567 545.621 539.782 545.847 537.877H470.301V537.862Z"
                  fill="white"
                />
                <path
                  d="M545.681 519.803C545.077 515.492 544.139 511.635 543.081 508.262C534.859 507.506 526.303 506.871 517.431 506.448C505.036 505.843 493.216 505.646 482 505.767C477.874 505.706 474.019 505.797 470.497 505.994L470.301 537.862H545.848C546.467 532.719 546.634 526.609 545.681 519.803Z"
                  fill="#41CBDD"
                />
                <path
                  d="M476.785 505.737C478.539 507.098 480.791 509.2 482.287 511.968C484.01 515.144 484.025 517.897 483.768 519.666"
                  stroke="white"
                  strokeWidth="3.2737"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M487.109 505.737C488.862 507.098 491.114 509.2 492.611 511.968C494.334 515.144 494.349 517.897 494.092 519.666"
                  stroke="white"
                  strokeWidth="3.2737"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <path
                d="M465.524 66.2263H319.857V332.634H465.524V66.2263Z"
                stroke="white"
                strokeWidth="2.8948"
                strokeMiterlimit="10"
              />
              <path
                d="M471.601 145.48C469.364 142.803 465.993 138.87 459.977 136.602C456.727 135.377 451.422 133.365 447.295 135.392C439.39 139.264 438.437 156.582 444.907 164.946C445.889 166.216 447.733 168.182 449.139 171.616C450.847 175.775 450.605 178.981 450.802 181.522C451.104 185.364 452.661 190.748 458.314 197.237C460.929 206.886 463.559 216.551 466.174 226.201C470.588 225.445 479.052 223.433 487.502 217.368C494.863 212.074 498.944 206.055 500.97 202.47C493.911 196.178 486.852 189.871 479.808 183.579C480.987 177.469 481.637 168.651 478.614 158.971C476.135 150.985 472.417 146.433 471.601 145.48Z"
                fill="#D1D0D1"
              />
              <path
                opacity="0.44"
                d="M246.351 66.2263H106.7V149.125H246.351V66.2263Z"
                fill="white"
              />
              <path
                opacity="0.44"
                d="M246.351 171.434H106.7V330.002H246.351V171.434Z"
                fill="white"
              />
              <path
                d="M246.351 67.5571H106.7V150.456H246.351V67.5571Z"
                stroke="white"
                strokeWidth="2.8948"
                strokeMiterlimit="10"
              />
              <path
                d="M246.351 172.75H106.7V331.318H246.351V172.75Z"
                stroke="white"
                strokeWidth="2.8948"
                strokeMiterlimit="10"
              />
              <path
                d="M412.545 287.033C423.761 291.691 438.604 296.35 456.395 298.089C492.158 301.598 520.726 291.449 536.129 284.477"
                stroke="#41CBDD"
                strokeWidth="3.8932"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M421.916 292.236C427.071 300.902 432.24 309.584 437.395 318.25C446.267 312.17 455.125 306.09 463.998 300.01C462.003 317.751 460.007 335.492 458.012 353.234C452.117 353.793 443.622 353.914 433.782 351.706C425.423 349.831 418.727 346.866 413.936 344.295C416.596 326.932 419.256 309.584 421.916 292.236Z"
                fill="#41CBDD"
              />
              <path
                d="M421.917 292.236C435.944 294.822 449.971 297.423 463.998 300.01C455.125 306.09 446.267 312.17 437.395 318.25C432.24 309.569 427.086 300.902 421.917 292.236Z"
                fill="white"
              />
              <path
                d="M469.908 272.982C469.953 273.39 469.999 273.799 470.044 274.207L458.254 275.356L458.541 278.245L451.664 278.926L451.966 281.981L458.843 281.3L459.131 284.189L470.981 283.025C471.026 283.524 471.087 284.023 471.132 284.522C471.933 284.855 473.097 285.218 474.533 285.278C475.213 285.309 475.818 285.248 476.332 285.172C476.302 285.263 475.621 287.214 476.846 288.727C477.874 289.982 479.763 290.375 481.38 289.589C481.501 290.224 481.622 290.844 481.743 291.479C484.419 291.237 487.079 291.011 489.754 290.769C490.087 290.254 490.419 289.725 490.737 289.211C493.836 289.528 498.295 289.543 503.298 288.046C505.157 287.486 506.805 286.806 508.225 286.11C509.616 288.137 511.279 291.071 512.337 294.882C513.848 300.358 513.35 304.759 513.214 305.742C512.896 308.238 512.261 310.264 511.717 311.671C509.903 312.11 508.089 312.548 506.276 312.987C505.233 315.119 504.205 317.237 503.162 319.369C503.993 322.697 504.84 326.024 505.671 329.337C514.256 326.735 522.827 324.119 531.412 321.517C529.387 316.844 527.362 312.185 525.336 307.512C524.611 300.932 522.842 291.963 518.383 282.208C515.828 276.597 512.941 271.938 510.251 268.218C496.798 269.821 483.345 271.409 469.908 272.982Z"
                fill="#41CBDD"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className={s.iconsPluses}>
        {iconPluses.map((el, i) => (
          <div key={i} className={s.iconPlus}>
            <div
              style={{
                mask: `url(${el.svgSrc}) no-repeat center`,
                WebkitMask: `url(${el.svgSrc}) no-repeat center`,
              }}
              className={s.icon}
            ></div>
            {el.text}
          </div>
        ))}
      </div>
    </>
  );
};

const mdtp = (dispatch) => ({
  messageChatErase: (p) => dispatch(messageChatErase(p)),
});
export default connect(null, mdtp)(FirstPage);
